export default "__VITE_ASSET__3$VIwA0S__ 778w";